import { HTMLAttributes, useEffect, useState } from "react";

const HolidayTip = (prop: HTMLAttributes<HTMLSpanElement>) => {
    const { isHoloday, tip } = useHolidayTip();

    return isHoloday ? <span {...prop}>{prop.children || tip}</span> : null
}

export const useHolidayTip = () => {
    const [isHoloday, setHoliday] = useState<boolean>(false);

    useEffect(() => {
        const currentTime = new Date().getTime();
        setHoliday(currentTime <= 1771862399000)
    }, [])

    return { isHoloday, tip: '春节假期间可下单，订单将在节后安排发货。' }
}



export default HolidayTip;